if (!customElements.get('cn-ugc-video')) {

  class cnUgcVideo extends HTMLElement {

    constructor() {
      super();

      if (this.hasChildNodes()) {
        this.init();
      }
    }

    async init() {

      this.addEventListener('click', this.handleClick.bind(this));

      const videos = this.querySelectorAll('video');

      videos.forEach((video) => {
        this.cnSetupUgcVideo(video, "card");
      });

      // =========================
      // Setup fullscreen video ONLY ONCE
      // =========================
      const popup_video = document.querySelector(
        "#cn_ugc_video_full_screen_popup_main .cn_ugc_fs_content video"
      );

      if (popup_video && !popup_video.dataset.initialized) {

        this.cnSetupUgcVideo(popup_video, "fs");

        popup_video.dataset.initialized = "true";
      }
    }

    cnSetupUgcVideo(video, card_or_fs) {

      // =========================
      // Prevent duplicate setup
      // =========================


      console.log("cn_test_log video", video)

      if (video.dataset.cnVideoSetup === "true") {
        return;
      }

      video.dataset.cnVideoSetup = "true";

      if (card_or_fs == "card") {

        var cnUgcVideoWrapper = video.closest('.cn_ugc_card');

      } else if (card_or_fs == "fs") {

        var cnUgcVideoWrapper = video.closest('.cn_ugc_fs_content');
      }

      const cnUgcVideoWrapperParent = cnUgcVideoWrapper.closest(".cn_ugc_cards_main");

      // Duration element
      const durationEl = cnUgcVideoWrapper.querySelector('.cn_ugc_video_detail_durations span');

      // Progress elements
      const progressBar = cnUgcVideoWrapper.querySelector('.cn_ugc_video_detail_progress');

      const progressFill = cnUgcVideoWrapper.querySelector('.cn_ugc_video_progress_fill');

      // Controls
      const controls = cnUgcVideoWrapper.querySelector('.cn_ugc_controls');

      const details = cnUgcVideoWrapper.querySelector('.cn_ugc_details');

      const playPauseBtn = cnUgcVideoWrapper.querySelector('.cn_ugc_control_btn_play_pause');

      const soundOnOffBtn = cnUgcVideoWrapper.querySelector('.cn_ugc_fs_sound_btn');

      let isDragging = false;

      let isHovered = false;

      let mobileControlsVisible = false;

      let hideTimer;

      /**
       * BUTTON VISIBILITY LOGIC
       */
      const updateControlsVisibility = () => {

        if (!playPauseBtn) return;

        const playIcon = playPauseBtn.querySelector('.cn_video_play_btn_icon');

        const pauseIcon = playPauseBtn.querySelector('.cn_video_pause_btn_icon');

        const isPlaying = !video.paused && !video.ended;

        const isMuted = video.muted;

        // =========================
        // VIDEO PAUSED
        // =========================
        if (!isPlaying) {

          playIcon?.classList.remove('cn_hidden');

          pauseIcon?.classList.add('cn_hidden');

          controls?.classList.remove('cn_controls_hidden');

          details?.classList.remove('cn_controls_hidden');

          return;
        }

        // =========================
        // VIDEO PLAYING
        // =========================
        playIcon?.classList.add('cn_hidden');

        pauseIcon?.classList.remove('cn_hidden');

        // desktop hover OR mobile visible state
        if (isHovered || mobileControlsVisible) {

          controls?.classList.remove('cn_controls_hidden');

          details?.classList.remove('cn_controls_hidden');

        } else {

          controls?.classList.add('cn_controls_hidden');

          details?.classList.add('cn_controls_hidden');
        }

        if (soundOnOffBtn) {

          const sounfOnIcon = cnUgcVideoWrapper.querySelector('.cn_ugc_fs_sound_on_btn');

          const soundOffIcon = cnUgcVideoWrapper.querySelector('.cn_ugc_fs_sound_off_btn');

          if (isMuted) {

            soundOffIcon?.classList.remove('cn_hidden');

            sounfOnIcon?.classList.add('cn_hidden');

          } else {

            sounfOnIcon?.classList.remove('cn_hidden');

            soundOffIcon?.classList.add('cn_hidden');
          }
        }
      };

      // =========================
      // Play pause events
      // =========================
      if (playPauseBtn) {

        playPauseBtn.addEventListener('click', (e) => {

          e.stopPropagation();

          if (!video) return;

          if (video.paused) {

            

            document.querySelectorAll(".cn_ugc_cards_main .cn_ugc_card video").forEach(element => {
              element.pause();
            });

            // cnUgcVideoWrapperParent.querySelectorAll("video").forEach(element => {
            //   element.pause();
            // });

            video.play();

          } else {

            video.pause();
          }
        });
      }

      // =========================
      // sound on and off events
      // =========================
      if (soundOnOffBtn) {

        const soundOnIcon = cnUgcVideoWrapper.querySelector('.cn_ugc_fs_sound_on_btn');

        const soundOffIcon = cnUgcVideoWrapper.querySelector('.cn_ugc_fs_sound_off_btn');

        soundOnOffBtn.addEventListener('click', (e) => {

          e.stopPropagation();

          if (!video) return;

          if (video.muted) {

            video.muted = false;

            soundOnIcon?.classList.remove('cn_hidden');

            soundOffIcon?.classList.add('cn_hidden');

          } else {

            video.muted = true;

            soundOffIcon?.classList.remove('cn_hidden');

            soundOnIcon?.classList.add('cn_hidden');
          }

          updateControlsVisibility();
        });
      }

      // =========================
      // HOVER EVENTS
      // =========================
      cnUgcVideoWrapper.addEventListener('pointerenter', () => {

        isHovered = true;

        updateControlsVisibility();
      });

      cnUgcVideoWrapper.addEventListener('pointerleave', () => {

        isHovered = false;

        updateControlsVisibility();
      });

      // =========================
      // TOUCH SUPPORT
      // =========================
      cnUgcVideoWrapper.addEventListener('touchstart', () => {

        // show controls
        mobileControlsVisible = true;

        updateControlsVisibility();

        // reset timer
        clearTimeout(hideTimer);

        // auto hide after delay
        hideTimer = setTimeout(() => {

          // only hide while playing
          if (!video.paused) {

            mobileControlsVisible = false;

            updateControlsVisibility();
          }

        }, 2000);
      });

      // =========================
      // VIDEO STATE EVENTS
      // =========================
      // video.addEventListener('play', updateControlsVisibility);
      video.addEventListener('play', () => {
        // adding event data to google tag and analytics
        console.log("cn_test_log video", video)
        var curr_product_handle = location.href.split("/products")[1];
        if(curr_product_handle.indexOf("?") != -1){
          curr_product_handle = location.href.split("/products")[1].split("?")[0];
        }
        console.log("cn_test_log curr_product_handle", curr_product_handle)
        gtag('event', 'atlas_ugc_play_click', {"product_url": curr_product_handle, "video_url": video.src});
        updateControlsVisibility();
      });

      video.addEventListener('pause', updateControlsVisibility);

      video.addEventListener('ended', updateControlsVisibility);

      // =========================
      // Updating video duration
      // =========================
      const updateDuration = () => {

        const currentFormatted = this.formatTime(video.currentTime || 0);

        const totalFormatted = this.formatTime(video.duration || 0);

        if (durationEl) {

          durationEl.textContent = `${currentFormatted} / ${totalFormatted}`;
        }
      };

      // =========================
      // Seek video progress
      // =========================
      const updateSeek = (clientX) => {

        if (!progressBar || !video.duration) return;

        const rect = progressBar.getBoundingClientRect();

        let percent = (clientX - rect.left) / rect.width;

        // Clamp between 0 and 1
        percent = Math.max(0, Math.min(1, percent));

        // Smooth seek
        video.currentTime = percent * video.duration;

        // Immediate UI update while dragging
        if (progressFill) {

          progressFill.style.width = `${percent * 100}%`;
        }

        updateDuration();
      };

      // =========================
      // Initial duration
      // =========================
      if (video.readyState >= 1) {

        updateDuration();

      } else {

        video.addEventListener('loadedmetadata', updateDuration, {
          once: true,
        });
      }

      // =========================
      // Time update
      // =========================
      video.addEventListener('timeupdate', () => {

        // Avoid fighting with drag updates
        if (isDragging) return;

        const percent = (video.currentTime / video.duration) * 100;

        if (progressFill) {

          progressFill.style.width = `${percent}%`;
        }

        updateDuration();
      });

      // =========================
      // Remove existing global handlers
      // =========================
      if (video._mousemoveHandler) {
        window.removeEventListener('mousemove', video._mousemoveHandler);
      }

      if (video._mouseupHandler) {
        window.removeEventListener('mouseup', video._mouseupHandler);
      }

      if (video._touchmoveHandler) {
        window.removeEventListener('touchmove', video._touchmoveHandler);
      }

      if (video._touchendHandler) {
        window.removeEventListener('touchend', video._touchendHandler);
      }

      // =========================
      // Global handlers
      // =========================
      video._mousemoveHandler = (e) => {

        if (!isDragging) return;

        updateSeek(e.clientX);
      };

      video._mouseupHandler = () => {

        isDragging = false;
      };

      video._touchmoveHandler = (e) => {

        if (!isDragging) return;

        updateSeek(e.touches[0].clientX);
      };

      video._touchendHandler = () => {

        isDragging = false;
      };

      window.addEventListener('mousemove', video._mousemoveHandler);

      window.addEventListener('mouseup', video._mouseupHandler);

      window.addEventListener('touchmove', video._touchmoveHandler);

      window.addEventListener('touchend', video._touchendHandler);

      // =========================
      // progressBar event handlers
      // =========================
      if (progressBar) {

        // Mouse
        progressBar.addEventListener('mousedown', (e) => {

          isDragging = true;

          updateSeek(e.clientX);
        });

        // Touch
        progressBar.addEventListener('touchstart', (e) => {

          isDragging = true;

          updateSeek(e.touches[0].clientX);
        });
      }

      // =========================
      // video end event handler
      // =========================
      video.addEventListener('ended', () => {

        // Only reset if loop is NOT enabled
        if (!video.loop) {

          video.currentTime = 0;

          if (progressFill) {

            progressFill.style.width = `0%`;
          }

          updateDuration();
        }
      });

      // =========================
      // INITIAL STATE
      // =========================
      updateControlsVisibility();
    }

    formatTime(seconds) {

      const mins = Math.floor(seconds / 60)
        .toString()
        .padStart(2, '0');

      const secs = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0');

      return `${mins}:${secs}`;
    }

    /**
     * Handles all click events via event delegation
     */
    handleClick(evt) {

      const fullscreenBtn = evt.target.closest('.cn_ugc_icon_fullscreen_btn');

      if (fullscreenBtn) {

        this.handleFullscreenClick(fullscreenBtn);

        return;
      }
    }

    handleFullscreenClick(btn) {

        const videoCard = btn.closest('.cn_ugc_card');

        const video = videoCard.querySelector('video');

        document.querySelectorAll(".cn_ugc_cards_main .cn_ugc_card video").forEach(element => {
            element.pause();
        });

        if (!video.paused) {

            video.pause();
        }

        const video_src = video.getAttribute("src");

        const cn_ugc_fs_popup = document.querySelector(
            "#cn_ugc_video_full_screen_popup_main"
        );

        const popup_video = document.querySelector(
            "#cn_ugc_video_full_screen_popup_main .cn_ugc_fs_content video"
        );

        // =========================
        // Setup fullscreen ONLY ONCE
        // =========================
        if (!popup_video.dataset.initialized) {

            this.cnSetupUgcVideo(popup_video, "fs");

            popup_video.dataset.initialized = "true";
        }

        popup_video.setAttribute("src", video_src);

        popup_video.currentTime = video.currentTime;

        // wait for enough buffer
        popup_video.onloadeddata = () => {
            popup_video.play().catch(console.error);
        };

        cn_ugc_fs_popup.style.display = "flex";

    }

    /**
     * Handles play pause of video
     */
    handlePlayPauseClick(btn) {

      const videoCardParent = btn.closest('.cn_ugc_card').parentNode;
      const videoCard = btn.closest('.cn_ugc_card');
      const video = videoCard.querySelector('video');

      if (!video) return;

      videoCardParent.querySelectorAll("video").forEach(element => {
        element.pause();
      });
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    }
  }


  customElements.define('cn-ugc-video', cnUgcVideo);
}